module.exports = __webpack_public_path__ + "img/amountFTD.7af92d90.svg";